import { AlertColor, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RegisterPageLeft from "./components/RegisterPageLeft";
import RegisterPageRight from "./components/RegisterPageRight";
import KeydriveSnackbar from "../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";

export interface IStepItem {
    stepNumber: number;
    stepContent: string;
    stepTitle: string;
    stepConcluded: boolean;
}

export interface IRegisterUserObject {
    email: string;
    username: string;
    password: string;
    confirmPassword: string;
    organizationName: string;
    privacyOk: boolean;
    emailOk: boolean;
}

export interface IStepHandler {
    currentStep: number;
    backStep: number;
}

export default function Register(): JSX.Element {

    const [step, setStep] = useState<number>(1);
    const { t } = useTranslation();
    const [createUserObject, setCreateUserObject] = useState<IRegisterUserObject>({
        confirmPassword: "",
        email: "",
        organizationName: "",
        password: "",
        username: "",
        privacyOk: false,
        emailOk: false
    });
    const [message, setMessage] = useState<string | undefined>(undefined);
    const [alertColor, setAlertColor] = useState<AlertColor>("success");
    const [privacyOk, setPrivacyOk] = useState<boolean>(false);
    const [emailOk, setSendEmailOk] = useState<boolean>(false);

    const [stepList, setSteplist] = useState<IStepItem[]>([
        {
            stepContent: t("RegisterPage.steps.step1.title"),
            stepTitle: t("RegisterPage.steps.step1.content"),
            stepNumber: 1,
            stepConcluded: false
        },
        {
            stepContent: t("RegisterPage.steps.step2.title"),
            stepTitle: t("RegisterPage.steps.step2.content"),
            stepNumber: 2,
            stepConcluded: false
        },
        {
            stepContent: t("RegisterPage.steps.step3.title"),
            stepTitle: t("RegisterPage.steps.step3.content"),
            stepNumber: 3,
            stepConcluded: false
        },
        {
            stepContent: t("RegisterPage.steps.step5.title"),
            stepTitle: t("RegisterPage.steps.step5.content"),
            stepNumber: 4,
            stepConcluded: false
        }
    ]);

    function forwardStep() {
        setStep(step => step + 1);
        let stepListCopy = stepList;
        stepList.forEach(stepItem => {
            if (stepItem.stepNumber == step) {
                stepItem.stepConcluded = true;
            }
        });
        setSteplist(stepListCopy);
    }

    function backStep() {
        if (step > 1) {
            setStep(step => step - 1);
            
            let stepListCopy = stepList;
            stepList.forEach(stepItem => {
                if (stepItem.stepNumber == step) {
                    stepItem.stepConcluded = false;
                }
            });
            setSteplist(stepListCopy);
        }
    }

    return (
        <Grid
            container
            spacing={1}
            display="flex"
            justifyContent="space-between"
        >
            <RegisterPageLeft
                step={step}
                steps={stepList}
                key={1}
            />
            <RegisterPageRight
                setCreateUserObject={setCreateUserObject}
                createUserObject={createUserObject}
                step={step}
                stepList={stepList}
                setStep={setStep}
                forwardStep={forwardStep}
                backStep={backStep}
                setMessage={setMessage}
                setAlertColor={setAlertColor}
                setPrivacyOk={setPrivacyOk}
                setSendEmailOk={setSendEmailOk}
                privacyOk={privacyOk}
                emailOk={emailOk}
            />
            <KeydriveSnackbar 
                open={message != undefined}
                variant={alertColor}
                message={message}
                onClose={() => {
                    setMessage(undefined);
                }}
            />
        </Grid>
    )
}